exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myreport-item .session-sub-header { float: right; margin-bottom: -20px; margin-top: -5px;}\r\n.myreport-item .session-sub-header li:last-child { margin-right: 0;}\r\n\r\n/* Features table left side border */\r\n.myreport-fulldetail-block .myreport-table table.dataTable.session-table td { border-left: 1px solid #E3E3E3;}\r\n.myreport-fulldetail-block .myreport-table table.dataTable.session-table td:last-child { border-right: 1px solid #E3E3E3;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/features/features.component.css
// module id = ../../../../../src/app/reports/myReports/features/features.component.css
// module chunks = main